import { Box, Drawer, styled } from "@mui/material";

// TODO: add to theme
export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  borderRadius: theme.spacing(1.5),
  height: "100%",
  [".MuiDrawer-paperAnchorRight"]: {
    width: "100%",
    maxWidth: "800px",
    display: "flex",
    flex: 1,
    gap: theme.spacing(3),
    flexDirection: "column",
    borderBottomLeftRadius: theme.spacing(1.5),
    borderTopLeftRadius: theme.spacing(1.5),
    padding: `${theme.spacing(5)} ${theme.spacing(5)} `,
  },
}));

export const TopContent = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-start",
});
